import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-missing-security-breakdown",
  // imports: [],
  templateUrl: "./missing-security-breakdown.component.html",
  styleUrl: "./missing-security-breakdown.component.css",
  standalone: false,
})
export class MissingSecurityBreakdownComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
